var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FollowRequestStatus } from '@amityco/js-sdk';
import { FormattedMessage, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import useUser from '../../../../core/hooks/useUser';
import useReport from '../../../../social/hooks/useReport';
import { notification } from '../../../../core/components/Notification';
import { Header, UserHeaderContainer, ListEmptyState, } from '../../../../social/pages/UserFeed/Followers/styles';
import UserHeader from '../../../../social/components/UserHeader';
import OptionMenu from '../../../../core/components/OptionMenu';
import PaginatedList from '../../../../core/components/PaginatedList';
import { Grid } from '../../../../social/components/community/CategoryCommunitiesList/styles';
import EmptyFeedIcon from '../../../../icons/EmptyFeed';
import Skeleton from '../../../../core/components/Skeleton';
import { useAsyncCallback } from '../../../../core/hooks/useAsyncCallback';
import { confirm } from '../../../../core/components/Confirm';
import useFollow from '../../../../core/hooks/useFollow';
import { useNavigation } from '../../../../social/providers/NavigationProvider';
import { UserFeedTabs } from '../constants';
const UserItem = ({ profileUserId, currentUserId, userId, allowRemoveUser, setUserFeedTab }) => {
    const { user } = useUser(userId);
    const { onClickUser } = useNavigation();
    const { formatMessage } = useIntl();
    const { isFlaggedByMe, handleReport } = useReport(user);
    const [onReportClick] = useAsyncCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield handleReport();
        notification.success({
            content: React.createElement(FormattedMessage, { id: "report.reportSent" }),
        });
    }), [handleReport]);
    const { deleteFollower } = useFollow(currentUserId, userId);
    const isMyProfile = profileUserId === currentUserId;
    const isMe = currentUserId === userId;
    const onRemoveClick = () => {
        confirm({
            title: (React.createElement(FormattedMessage, { id: "follower.title.removeUser", values: { displayName: user.displayName } })),
            content: (React.createElement(FormattedMessage, { id: "follower.body.removeUser", values: { displayName: user.displayName } })),
            cancelText: formatMessage({ id: 'buttonText.cancel' }),
            okText: formatMessage({ id: 'buttonText.remove' }),
            onOk: deleteFollower,
        });
    };
    const onClickUserHeader = useCallback(() => {
        onClickUser(userId);
        setUserFeedTab(UserFeedTabs.TIMELINE);
    }, [onClickUser, setUserFeedTab, userId]);
    return (React.createElement(UserHeaderContainer, { key: userId },
        React.createElement(Header, null,
            React.createElement(UserHeader, { userId: userId, isBanned: user.isGlobalBan, onClick: onClickUserHeader }),
            React.createElement(OptionMenu, { options: [
                    !isMe && {
                        name: isFlaggedByMe ? 'report.unreportUser' : 'report.reportUser',
                        action: onReportClick,
                    },
                    allowRemoveUser &&
                        isMyProfile && {
                        name: 'follower.menuItem.removeUser',
                        action: onRemoveClick,
                    },
                ].filter(Boolean) }))));
};
const List = ({ profileUserId, currentUserId, hook, emptyMessage, allowRemoveUser, setUserFeedTab, }) => {
    const [followings, hasMore, loadMore, loading, loadingMore] = hook(profileUserId, FollowRequestStatus.Accepted);
    const items = useMemo(() => {
        function getLoadingItems() {
            return new Array(5).fill(1).map((x, index) => ({ userId: index, skeleton: true }));
        }
        if (loading) {
            return getLoadingItems();
        }
        if (!loadingMore) {
            return followings;
        }
        return [...followings, ...getLoadingItems()];
    }, [followings, loading, loadingMore]);
    return (React.createElement(PaginatedList, { items: items, hasMore: hasMore, loadMore: loadMore, container: Grid, emptyState: React.createElement(ListEmptyState, { icon: React.createElement(EmptyFeedIcon, { width: 48, height: 48 }), title: "It's empty here...", description: emptyMessage }) }, ({ skeleton, userId }) => skeleton ? (React.createElement(Skeleton, { count: 3, style: { fontSize: 8 } })) : (React.createElement(UserItem, { key: userId, userId: userId, currentUserId: currentUserId, profileUserId: profileUserId, allowRemoveUser: allowRemoveUser, setUserFeedTab: setUserFeedTab }))));
};
export default List;
//# sourceMappingURL=List.js.map